import { useCallback } from 'react';

import * as server from '../server';

export const useGetBalanceHistory = () => {
    return useCallback(async ({
        startDate,
        endDate,
        clientType,
        orderByDate,
        returnSummary,
        transactionGroups,
        ignorePlayerViewConf,
        ignoreStartingEndingBalances,
        pagerRequest
    }) => {
        const response = await server.getBalanceHistory({
            startDate,
            endDate,
            clientType,
            orderByDate,
            returnSummary,
            transactionGroups,
            ignorePlayerViewConf,
            ignoreStartingEndingBalances,
            pagerRequest
        });

        const {
            pagerResponse = {},
            endingBalances = [],
            startingBalances = [],
            walletTransactions = [],
            defaultTypeNames = [],
            usedTagsDefaults = [],
            usedTemplates = [],
            summary = {}
        } = response?.data ?? {};

        return {
            pagerResponse,
            endingBalances,
            startingBalances,
            walletTransactions,
            defaultTypeNames,
            usedTagsDefaults,
            usedTemplates,
            summary
        };
    }, []);
};
